import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import { Link } from "react-router-dom";

import './Footer.css';

import {
  Container,
  Row,
  Col
} from 'reactstrap';

import somCoop from '../images/som_coop_blanco.png';
import logo_fse from '../images/subventions/logo_FSE_white.png';

class Footer extends Component {

  render() {
    return (
      <footer>
        <Container>
          <Row>
            <Col md="4">
              <span className="copyright light">Gone Mad Studios - 2020</span>
              <img className="coop" src={somCoop} alt="SomCOOP" />
            </Col>
            <Col md="4">
              <ul className="list-inline social-buttons">
                <li className="list-inline-item">
                  <a href="https://twitter.com/GoneMadStudios" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="https://www.facebook.com/GoneMadStudios/" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="https://www.instagram.com/gonemadstudios/" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="https://www.linkedin.com/company/gone-mad-studios/" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </li>
              </ul>
            </Col>
            <Col md="4">
              <ul className="list-inline quicklinks">
                <li className="list-inline-item">
                  <Link to="/subventions" className="light">
                    <img className="fse" src={logo_fse} alt="FSE" />
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link to="/terms_and_policy" className="light"><Translate id="footer.termsandpolicy">Términos y Condiciones de Uso</Translate></Link>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </footer>
      );
  }
}

export default Footer;
